module.exports = __webpack_public_path__ + "img/bg.d504d31c.webp";